/**
 * footer-inner内のサブメニュー開閉制御（SP時のみ）。
 *
 * 仕様:
 * ・サブメニューを持つ親は、WordPress標準の挙動では常に<button>として
 *   レンダリングされる（親自体にリンクを設定していても<a>にはならない）。
 *   親にリンクを設定している場合、コアはサブメニューの先頭に「親と同じ
 *   ラベル・リンク先を持つ複製項目」を自動生成する（リンク未設定の場合も
 *   複製項目自体は生成されるが、リンク先は "#" になる）。
 *   そのため、この複製項目のリンク先が "#" 以外の実URLかどうかで
 *   「親にリンクがあるかどうか」を判定する。
 * ・親にリンクがある項目（.has-parent-link）は開閉トグルとして扱わず、
 *   常に展開したリンク一覧として表示する。矢印アイコンクリックは無視し、
 *   ラベルクリックのみ複製項目が持つリンク先へ遷移させる。
 * ・親にリンクがない項目（通常のトグルのみの<button>）は、ラベル・矢印
 *   アイコンのどちらをクリックしても開閉のみを行う（ページ遷移はしない）。
 * ・".parent-menu-items-pc" が付与された項目（PCのみ常時展開表示にしたい
 *   項目）は、上記の「親にリンクがあるかどうか」判定・.has-parent-link
 *   付与の対象から除外する。これにより、たとえ親自体にリンクが設定されて
 *   いても SP 時は常時展開扱いにならず、通常の開閉トグル（折りたたみ表示）
 *   として動作する。PC時の常時展開表示は _footer.scss 側の
 *   .parent-menu-items-pc 用スタイルで別途制御している。
 *
 * 以前はWP標準のクリック処理（Interactivity APIのtoggleMenuOnClick）に
 * 委ねていたが、1つのサブメニューを開いた状態で別のサブメニューの矢印を
 * 押すと、新しい方は開かずに先に開いていた方が閉じてしまう不具合があった。
 * これはWP標準側の内部状態管理と、当時実装していた「トグルボタンのクリックを
 * 代理発火させる」処理が干渉していたことが原因と考えられる。
 * そのため、開閉状態の管理を完全に自前で行い、WP標準の処理には一切委ねない
 * ようにする（documentのキャプチャフェーズでクリックを横取りし、WP側の
 * ハンドラーには到達させない）。これにより各項目は完全に独立して開閉でき、
 * 複数の項目を同時に開いた状態でも問題ない。
 */
( function () {
	const nav = document.querySelector( '.footer-inner .wp-block-navigation' );
	if ( ! nav ) return;

	const isMobile = () => window.matchMedia( '(max-width: 1179.98px)' ).matches;

	nav.querySelectorAll( '.wp-block-navigation-item.has-child' ).forEach( ( item ) => {
		if ( item.classList.contains( 'parent-menu-items-pc' ) ) return;

		const duplicateLink = item.querySelector(
			':scope > .wp-block-navigation__submenu-container > .wp-block-navigation-item:first-child > a.wp-block-navigation-item__content'
		);
		if ( ! duplicateLink ) return;

		const href = duplicateLink.getAttribute( 'href' );
		if ( ! href || '#' === href ) return;

		item.classList.add( 'has-parent-link' );
		item.dataset.parentHref = href;

		const icon = item.querySelector( ':scope > .wp-block-navigation__submenu-icon' );
		if ( icon ) {
			icon.setAttribute( 'aria-expanded', 'true' );
		}
	} );

	document.addEventListener( 'click', ( event ) => {
		if ( ! isMobile() ) return;

		const hit = event.target.closest(
			'.wp-block-navigation-item__content.wp-block-navigation-submenu__toggle, .wp-block-navigation__submenu-icon'
		);
		if ( ! hit || ! nav.contains( hit ) ) return;

		const item = hit.closest( '.wp-block-navigation-item.has-child' );
		if ( ! item ) return;

		if ( item.classList.contains( 'has-parent-link' ) ) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			if (
				hit.classList.contains( 'wp-block-navigation-item__content' ) &&
				item.dataset.parentHref
			) {
				window.location.href = item.dataset.parentHref;
			}
			return;
		}

		const toggle = item.querySelector( ':scope > .wp-block-navigation-item__content.wp-block-navigation-submenu__toggle' );
		if ( ! toggle || 'BUTTON' !== toggle.tagName ) return;

		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();

		const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
		toggle.setAttribute( 'aria-expanded', String( ! isOpen ) );
	}, true );
} )();
